const appConfig = {
  debounceTimeout: 750,
  expirationTime: 10 * 60 * 60 * 1000, // 10 hours

  // For production
// baseURL: "https://clickstock.org", 
  //baseurlAPI: "https://clickstock.org/api", // Clean API path
 //  baseURL: "http://3.213.27.68:8000/",
   //baseurlAPI: "http://3.213.27.68:8000/api",
  // For local dev
  //baseURL: "http://127.0.0.1:8000",
  //baseurlAPI: "http://127.0.0.1:8000/api",
  //Staging Area
  baseURL:"https://capable-peach-emu.176-9-116-24.cpanel.site",
  baseurlAPI:"https://capable-peach-emu.176-9-116-24.cpanel.site/api",
};


export default appConfig;
